// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yd97m","badges":"styles_badges__HQpZ2"};